import { useEffect } from 'react';
import { productFilterSlice } from '../../store/productFilterSlice';
import { useGetBrandsQuery } from '../api/brand/queries/useGetBrands.query';
import { useAppDispatch, useAppSelector } from '../store/useStore';

interface useAddFilterOptions {
  data: 'brands';
}

export const useAddFilterOptions = ({ data }: useAddFilterOptions) => {
  const dispatch = useAppDispatch();
  const productFilterStates = useAppSelector((state) => state.productFilter);
  const productFilterActions = productFilterSlice.actions;

  const { data: brands, isSuccess: isGetBrandsQuerySuccess } = useGetBrandsQuery();

  useEffect(() => {
    if (data === 'brands') {
      if (!productFilterStates.isFilterOptionsAdded.brands && isGetBrandsQuerySuccess && brands.length > 0) {
        dispatch(
          productFilterActions.addFilterOptions({
            filterKey: 'filter_brand',
            options: brands.map((brand) => {
              return {
                optionName: brand.name,
                value: brand.id,
                isDefault: false,
                isSelected: false,
              };
            }),
          }),
        );

        dispatch(productFilterActions.changeIsFilterOptionsAdded({ data: 'brands', value: true }));
      }
    }
  }, [productFilterStates.isFilterOptionsAdded, brands]);
};
